import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3edcfcde&scoped=true&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&id=3edcfcde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edcfcde",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLayout: require('/app/components/AppLayout.vue').default,CoreNotification: require('/app/components/core/Notification.vue').default})
